import React from 'react';
import _ from 'lodash';
import './EmptyValue.scss';

export const EMPTY_VALUE_CHARACTER = '—';

export const isBlankValue = (value) => (
  _.isNil(value) || (_.isString(value) && _.trim(value) === '')
);

const EmptyValue = () => (
  <span className="empty-value">{EMPTY_VALUE_CHARACTER}</span>
);

export default EmptyValue;
